
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const router = useRouter();
    const popupStore = usePopupStore();

    const closePopup = () => {
      popupStore.togglePopup('logoutAlert', false);
    }

    const handleConfirmClick = () => {
      closePopup();
      router.push({ name: 'login' });
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick
    };
  },
});
